import { ColorInputModal } from "./ColorInputModal";

export default ColorInputModal;
